module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Boka demo":"Book a demo","Kom igång gratis":"Get started for free","Våra prismodeller":"Our price models","asd":"asd"},"sv":{"Boka demo":"Boka demo","Kom igång gratis":"Kom igång gratis","Våra prismodeller":"Våra prismodeller","asd":"asd"}}')
  delete Component.options._Ctor
}
